<template>
    <default-item class="menu--item-back_bar_default" :item="itemFormatted" layout="price-inline" tag-location="before-title"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for Back Bar items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.2
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-12-19 (1.0.0) (jhoward)
 *      - <WVSteakHouseFoodItem> copied to <back-bar-default-item>.
 *
 *    2024-07-19 (1.0.1) (jhoward)
 *      - Rename .visual_menu--tag CSS rules to .menu--tag in <back-bar-default-item>.
 *
 *    2025-04-08 (1.0.2) (jhoward)
 *      - Remove "visual_" prefix from class names in <back-bar-default-item>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'BackBarDefaultItem',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
  computed: {
    itemFormatted(): MenuItem {
      const output = {...this.item};
      output.mi_title = output.mi_title.replace(/\*/g, '<span class="menu--item_title_asterisk">*</span>');
      return output;
    }
  }
})
</script>

<style scoped>
.menu--item-back_bar_default {
  text-align: center;
}

.menu--item-back_bar_default:deep(.menu--item_title_asterisk) {
  font-family: BodyFont, sans-serif;
}

.menu--item-back_bar_default:deep(.menu--item_description) {
  font-family: minion-pro, serif;
  font-weight: 400;
  font-style: normal;
}

.menu--item-back_bar_default:deep(.menu--item_title) {
  font-family: muchacho, serif;
  font-weight: 700;
  font-style: normal;
  font-size: 1.1em;
}

.textual_menu--container .menu--item-back_bar_default:deep(.menu--item_title) {
  font-size: 1.2em;
}

.menu--item-back_bar_default:deep(.menu--item_price) {
  margin-left: 0.25em;
}

.menu--section .menu--item-back_bar_default:not(.menu--item-multi_line_price) {
  grid-template-columns: 1fr;
  grid-gap: 0.5em;
}

.menu--item-back_bar_default:deep(.menu--tag) {
  position: relative;
  right: initial;
  width: 1.3em;
  height: 1.3em;
  top: -0.2em;
}
</style>